var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPctStep01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 110,
    viewBox: "0 0 150 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_1427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9449 34H91.9393C92.4127 34 92.8 34.522 92.8 35.1601V37.4571C92.8 38.3155 92.2836 39 91.6552 39H58.9449C58.3079 39 57.8 38.3039 57.8 37.4571V35.5429C57.8 34.6845 58.3165 34 58.9449 34Z",
    fill: "#CEDFFF",
    stroke: "#82BCFF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6555 43H58.9446C58.3125 43 57.8 43.6908 57.8 44.5429V46.4571C57.8 47.3092 58.3125 48 58.9446 48H91.6555C92.2876 48 92.8 47.3092 92.8 46.4571V44.5429C92.8 43.6908 92.2876 43 91.6555 43Z",
    fill: "#CEDFFF",
    stroke: "#82BCFF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2405 69.2665V26.1378H96.4121L96.6025 28.9944H48.0973V69.2665H45.2405Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.019 69.6273V18.0693H37.1714V69.6273H33.1017V17.5481C33.1017 16.5959 33.4726 15.7039 34.1442 15.0424C34.8158 14.3708 35.7079 14 36.6501 14H112.53C113.483 14 114.365 14.3708 115.036 15.0424C115.708 15.7139 116.079 16.606 116.079 17.5481V69.6273H112.009H112.019Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8864 90.8961C29.042 90.8961 27.3179 90.1844 26.0148 88.8814C24.7117 87.5785 24 85.8545 24 84.0103V74.699H125V84.0103C125 85.8545 124.288 87.5785 122.985 88.8814C121.682 90.1844 119.958 90.8961 118.114 90.8961H30.8864ZM27.9394 84.0103C27.9394 84.762 28.2301 85.4736 28.7713 86.0049C29.3126 86.5361 30.0143 86.8368 30.7661 86.8368H118.294C119.036 86.8368 119.768 86.5361 120.289 86.0049C120.82 85.4736 121.121 84.762 121.121 84.0103V78.3373H89.225L88.9644 77.9464C88.6637 78.6681 88.1625 79.2694 87.5109 79.7004C86.8594 80.1314 86.1076 80.3619 85.3257 80.372H63.6943C62.9225 80.372 62.1707 80.1414 61.5192 79.7004C60.8676 79.2694 60.3664 78.658 60.0657 77.9464L59.8051 78.3373H27.9394V84.0103Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3129 52.6084H60.5168C58.9889 52.6084 57.7502 53.8469 57.7502 55.3747V65.4277C57.7502 66.9555 58.9889 68.1941 60.5168 68.1941H88.3129C89.8408 68.1941 91.0794 66.9555 91.0794 65.4277V55.3747C91.0794 53.8469 89.8408 52.6084 88.3129 52.6084Z",
    stroke: "#82BCFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3581 55.4348H62.4613C61.3431 55.4348 60.4365 56.3413 60.4365 57.4594V63.3429C60.4365 64.4611 61.3431 65.3676 62.4613 65.3676H86.3581C87.4764 65.3676 88.3829 64.4611 88.3829 63.3429V57.4594C88.3829 56.3413 87.4764 55.4348 86.3581 55.4348Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3653 72.8147L80.5845 68.9258L79.8527 68.8456V61.9598C79.8527 60.6468 79.3415 59.414 78.4193 58.4919C77.4871 57.5698 76.2542 57.0586 74.9511 57.0586C73.648 57.0586 72.405 57.5698 71.4828 58.4919C70.5506 59.414 70.0394 60.6568 70.0394 61.9598V78.7583C65.1277 76.2726 62.6418 77.4653 61.4891 78.628L57.8705 82.3866L64.7268 88.26L64.6666 88.4705L65.1277 88.6108L70.7711 93.4419C70.8614 93.5822 70.9516 93.7526 71.0618 93.933C71.7735 95.1558 72.8561 97.0101 74.9511 97.0101H89.5758C93.3347 96.8697 95.3997 91.9886 95.4999 89.2022V79.5401C95.6903 75.6912 90.9391 73.4561 89.3653 72.8247V72.8147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7058 61.9597C72.7058 61.3684 72.9363 60.7971 73.3573 60.3761C73.7783 59.9551 74.3497 59.7246 74.9411 59.7246C75.5325 59.7246 76.1039 59.9551 76.5249 60.3761C76.9459 60.7971 77.1764 61.3684 77.1764 61.9597V71.241L79.8828 71.5316L88.3329 75.2802C88.3329 75.2802 93.004 77.1345 92.8236 79.4498V89.1921C92.7534 91.0263 91.3 94.2637 89.4756 94.3238H74.9511C74.0991 94.3238 73.2972 92.209 72.7158 91.5775L61.7598 82.186L63.4137 80.4621C65.5788 78.2971 72.7158 83.5892 72.7158 83.5892V61.9497L72.7058 61.9597Z",
    fill: "#50A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5 34.87H101.93V65.7H104.5V34.87Z",
    fill: "#82BCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_1427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 83,
    fill: "white",
    transform: "translate(24 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPctStep01);
export default __webpack_public_path__ + "static/media/pct_step01.854f31b9f529e36426a8c368c6f59488.svg";
export { ForwardRef as ReactComponent };